import React from "react";
import {cx} from "../../lib/ClassSet";
import "./WarehouseItem.css";

const WarehouseItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "inventory-warehouse-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("id")}</td>
      <td className="field f-location">{data.get("location")}</td>
      <td className="field f-id f-nolink">{data.get("backup_warehouse_id")}</td>
      <td className="field f-id f-nolink">{data.getIn(["info","system"], "")}</td>
      <td className="field f-courier">{data.get("courier_id")}</td>
    </tr>
  )
}

export default WarehouseItem;